import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import PendingIcon from "@mui/icons-material/Pending";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

import CustomButton from "../../helper-components/input/CustomButton.jsx";

import { formatText } from "../shared/miscUtils.js";
import { defaultButton, defaultId, defaultStatus, defaultStatusMsg, defaultStyle, defaultText, defaultTime } from "./shared.js";

// Custom functions for table columns.
const clickButton = (props, params) => {
    props.browser.navigate(`/highlights/view/${params.row.id}`);
};

const createTitle = (props, params) => {
    return "View";
};

const disableButton = (props, params) => {
    return false;
};

const renderStatus = (params) => {
    const status = params.row?.status;
    const formatted = formatText(status);

    if (status === "AWAITING_APPROVAL") {
        return <CustomButton icon={<PendingIcon className="cursor-default" />} tooltip={formatted} />;
    } else if (status === "APPROVED") {
        return <CustomButton icon={<ThumbUpIcon className="cursor-default" />} tooltip={formatted} />;
    } else if (status === "REJECTED") {
        return <CustomButton icon={<ThumbDownIcon className="cursor-default" />} tooltip={formatted} />;
    } else if (status === "COMPLETED") {
        return <CustomButton icon={<OndemandVideoIcon className="cursor-default" />} tooltip={formatted} />;
    }

    return <CustomButton icon={<QuestionMarkIcon className="cursor-default" />} tooltip={formatted} />;
};

// Column definitions.
const request = (props) => ({
    ...defaultStyle,
    field: "highlight_request.name",
    headerName: "Request",
    flex: 0.1,
    minWidth: 100,
    valueGetter: (params) => params.row?.highlight_request?.name ?? "N/A"
});

const resource = (props) => ({
    ...defaultStyle,
    field: "resource.name",
    headerName: "Resource",
    flex: 0.2,
    minWidth: 175,
    valueGetter: (params) => params.row?.resource?.name ?? "N/A"
});

const text = { ...defaultStyle, field: "text", headerName: "Highlight", flex: 0.25, minWidth: 200 };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const status = { ...defaultStatus(), renderCell: (params) => renderStatus(params) };
const statusMsg = { ...defaultStatusMsg };
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickButton, disabled: disableButton, title: createTitle }), minWidth: 100, flex: 0.1 };
};

const reviewEmail = {
    ...defaultStyle,
    field: "highlight_reviews.user.email",
    headerName: "Reviewer",
    flex: 0.2,
    minWidth: 200,
    valueGetter: (params) => params.row?.user?.email ?? "N/A"
};

const reviewRole = {
    ...defaultStyle,
    field: "highlight_reviews.user.role.role",
    headerName: "Role",
    minWidth: 125,
    valueGetter: (params) => formatText(params.row?.user?.role?.role)
};

const reviewVote = {
    ...defaultStyle,
    field: "status",
    headerName: "Vote",
    minWidth: 75,
    valueGetter: (params) => params.row?.vote ?? "N/A"
};

const reviewNote = { ...defaultText("note"), field: "highlight_reviews.text", headerName: "Comment", flex: 0.35, minWidth: 200 };

// Table columns.
export const columns = (props) => [defaultId, request(props), resource(props), text, status, createdOn, updatedOn, statusMsg, action(props)];

export const reviewColumns = (props) => [defaultId, reviewEmail, reviewRole, createdOn, reviewVote, reviewNote];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

export const isReviewRowSelectable = (props, params) => {
    return params.row?.id !== -1; // Prevent selecting the "system review" row.
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};

export const defaultReviewTableOptions = {
    isRowSelectable: isReviewRowSelectable,
    checkboxSelection: true
};
